var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 40.76,
    x2: 50.83,
    y1: 23,
    y2: 40.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ca3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9ca3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b7280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.56,
    x2: 39.2,
    y1: 21.96,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#848b98",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M34.23 33.45a4.05 4.05 0 0 0 4.05 4h16.51a4.34 4.34 0 0 0 .81-8.61 3.52 3.52 0 0 0 .06-.66 4.06 4.06 0 0 0-6.13-3.48 6.08 6.08 0 0 0-11.25 3.19 6.34 6.34 0 0 0 .18 1.46h-.18a4.05 4.05 0 0 0-4.05 4.1z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-2.1 0; 2.1 0; -2.1 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M46.5 31.5h-.32a10.49 10.49 0 0 0-19.11-8 7 7 0 0 0-10.57 6 7.21 7.21 0 0 0 .1 1.14A7.5 7.5 0 0 0 18 45.5a4.19 4.19 0 0 0 .5 0h28a7 7 0 0 0 0-14z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-3 0; 3 0; -3 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.9237af3fb8cf0403c0ad2cd7c649d561.svg";
export { ForwardRef as ReactComponent };